import React from 'react';
import Media from 'react-media';
import styles from './Showcase.module.scss';
import { MOBILE_WIDTH } from '../../../constants';

const Showcase = (props) => {
	const { bubbleStyle, containerClass } = props;
	const { title, content, featureTitle, features, imageSource } = props.item;

	// console.log('*** imageSource: ', imageSource);
	const {
		container,
		containerSM,
		left,
		middle,
		middleSM,
		right,
		leftSM,
		rightSM,
		titleStyle,
		contentStyle,
		titleStyleSM,
		contentStyleSM,
		image,
	} = styles;
	return (
		<Media query={{ maxWidth: MOBILE_WIDTH }}>
			{(matches) => (
				<div className={`${matches ? containerSM : container} ${containerClass}`}>
					<div className={`${matches ? leftSM : left} ${bubbleStyle}`}>
						<div className={matches ? titleStyleSM : titleStyle}>{title}</div>
						<div className={`${matches ? contentStyleSM : contentStyle}`}>{content}</div>
					</div>

					<div className={`${matches ? middleSM : middle}`}>
						<img src={imageSource} width='56%' className={image} alt='' />
					</div>

					<div className={`${matches ? rightSM : right} ${bubbleStyle}`}>
						<div className={matches ? titleStyleSM : titleStyle}>{featureTitle}</div>
						<div className={`${matches ? contentStyleSM : contentStyle}`}>
							<ul>
								{features.map((item) => {
									return <li key={item}>{item}</li>;
								})}
							</ul>
						</div>
					</div>

					{props.children}
				</div>
			)}
		</Media>
	);
};

export default Showcase;
